export default {
    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    dialogFullscreen: state => state.app.dialogFullscreen,
    token: state => state.admin.token,
    info: state => state.admin.info,
    labelPosition: state => state.app.labelPosition,
    msg: state => state.app.redMsg,

    socket: state => state.historyMessage.socket,
    historyMessage: state => state.historyMessage.historyMessage,
    historyMessageStr: state => state.historyMessage.historyMessageStr,
    isPositionEnd: state => state.historyMessage.isPositionEnd,
    msgTotal: state => state.historyMessage.msgTotal,
    onlineState: state => state.historyMessage.onlineState,
    onlineDisabled: state => state.historyMessage.onlineDisabled,
    autoReconnect: state => state.historyMessage.autoReconnect,

    theme: state => state.theme.current,
    themeOptions: state => state.theme.options,
};
